









































































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import Customer from '@/models/Customer';
import formatCustomer from '@/utils/formatCustomer';
import Address from '@/models/Address';
import compact from 'lodash/compact';
import moment from 'moment';
import { getCustomersPrescriber } from '@/api/api';
import debounce from 'lodash/debounce';
import MetaDatatable from '@/models/MetaDatatable';
import ImportProspectsModal from '@/components/prescriber/ImportProspectsModal.vue';
import {
    customerStatusMini,
    formatCustomerStatus,
    customerStatusColors,
} from '@/data/customerStatus';

@Component({
    components: {
        ImportProspectsModal,
    },
    filters: {
        formatCustomer,
        formatAddress(address: Address) {
            if (!address) {
                return '';
            }
            return `${address.city} (${address.postal_code})`;
        },
        formatDate(date: string) {
            return moment(date).format('L');
        },
        formatCustomerStatus,
    },
})
export default class ProspectsList extends Vue {
    searchStr: string = '';
    customers: Customer[] = [];
    loading: boolean = false;
    loadingContent: boolean = false;
    showImportModal: boolean = false;
    isSidebarOpen: boolean = false;


    meta: MetaDatatable = {
    total: 0,
    pages: 0,
    page: 0,
    perPage: 10,
    search: null,
    orderBy: 'createdAt',
    orderWay: 'desc',
    filters: {
        prescribers: undefined,
        status: undefined,
    },
};

    status: string | null = null;

    async created() {
        this.loading = true;
        await this.fetch();
        this.loading = false;
    }




    async fetch() {
        this.loadingContent = true;
            try {
                const { data } = await getCustomersPrescriber(this.meta);
                this.customers = data.data;
                this.meta.total = data.meta ? data.meta.total : 0;
                this.meta.pages = data.meta ? data.meta.pages : 1;
                this.meta.page = data.meta ? data.meta.page : 0;

                if (
                    this.customers.length > 0 &&
                    !this.$route.params.customerID &&
                    this.$route.name !== 'prospectsTable'
                ) {
                    this.$router.push({
                        name: 'showProspect',
                        params: { customerID: String(this.customers[0].id) },
                    });
                }
            } catch (e) {
                this.customers = [];
            }
            this.loadingContent = false;
    }



    async goToPage(page: number) {
        if (page < 0 || page >= this.meta.pages) return;
        this.meta.page = page;
        await this.fetch();
    }

    get paginationInfo(): string {
        const start = this.meta.page * this.meta.perPage + 1;
        const end = Math.min((this.meta.page + 1) * this.meta.perPage, this.meta.total);
        return `${start}-${end} sur ${this.meta.total}`;
    }

    debouncedOnSearchChange = debounce(this.onSearchChange, 300);

    onSearchChange() {
        this.meta.search = this.searchStr;
        this.meta.page = 0;
        this.fetch();
    }

    @Watch('searchStr')
    onSearch() {
        this.debouncedOnSearchChange();
    }

    onStatusChange() {
        this.meta.filters.status = this.status;
        this.meta.page = 1;
        this.fetch();
    }

    async onImported() {
        this.meta.page = 1;
        await this.fetch();
    }

    selectProspect(customer: Customer) {
        this.$router.push({ 
            name: 'showProspect', 
            params: { customerID: String(customer.id) } 
        });
        
        if (window.innerWidth <= 1024) {
            this.isSidebarOpen = false;
        }
    }

    getCustomerStatusColor(
        status: 'in_progress' | 'standby' | 'archived' | 'processed'
    ) {
        if (status in customerStatusColors) {
            return customerStatusColors[status];
        }
        return `rgba(var(--vs-primary), 1)`;
    }

    get customerStatus() {
        return Object.entries(customerStatusMini).map(([key, value]) => ({
            text: value,
            value: key,
        }));
    }
}
